import React from "react";
import { InputLabel, Stack } from "@mui/material";
import { StyledBox, StyledTypography } from "../style.module";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Controller, useFormContext } from "react-hook-form";
import { IsLoggedInUserViewer } from "../../../hoc/withAuthRedirect";
import { t } from "i18next";

const FormRadioButton = ({ name, elementId, isRequired, inputLabel, isDisabled }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Stack autoComplete="off">
      <InputLabel htmlFor={elementId}>
        <StyledBox>
          {isRequired && (
            <StyledTypography variant="subtitle2" gutterBottom typostyle={{ color: "red" }}>
              *
            </StyledTypography>
          )}
          <StyledTypography variant="subtitle2" gutterBottom typostyle={{ color: "#000000", fontSize: "0.8rem" }}>
            {inputLabel}
          </StyledTypography>
        </StyledBox>
      </InputLabel>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <RadioGroup
            {...field}
            name="controlled-radio-buttons-group"
            style={{ display: "flex", flexDirection: "row" }}
            onChange={(e) => {
              console.log(e);
              field.onChange(e);
            }}
            disabled={IsLoggedInUserViewer() || isDisabled}
          >
            <FormControlLabel
              value="true"
              control={<Radio sx={{ fontSize: "0.8rem", color: "#605a59" }} />}
              label={<span style={{ fontSize: "0.8rem", color: "#000000" }}>{t("createDevice.true")}</span>}
              disabled={IsLoggedInUserViewer() || isDisabled}
            />
            <FormControlLabel
              value="false"
              control={<Radio sx={{ fontSize: "0.8rem", color: "#605a59" }} />}
              label={<span style={{ fontSize: "0.8rem", color: "#000000" }}>{t("createDevice.false")}</span>}
              disabled={IsLoggedInUserViewer() || isDisabled}
            />
          </RadioGroup>
        )}
      />
      {errors[name] && (
        <StyledTypography variant="body2" typostyle={{ color: "red" }}>
          {errors[name].message}
        </StyledTypography>
      )}
    </Stack>
  );
};

export default FormRadioButton;
